module.exports = __webpack_public_path__ + "img/springroll_fold_1.6b8e1f1b.jpg";